import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { invokeGetService, setFocusElement, setForcedFocus, setTabOnFocus, toggleRightDrawer } from "../store/global/actions";
import {  getRightDrawerStatus } from "../store/global/selectors";
import { useHistory } from "react-router-dom";
import { getDetailsFromUrl } from "../services/blueprint";
import { logWarn } from "../utils/logger";

const useConstructsNavigation = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [events, setEvents] = useState(false);
    const [transactions, setTransactions] = useState(false);
    const [clusterlets, setClusterlets] = useState(false);
    const [routingRules, setRoutingRules] = useState(false);
    const [views, setViews] = useState(false);
    const [testsuites, setTestsuites] = useState([]);
    
    let tab = 0;

    const { slug, blueprintId, screen, entityId } = getDetailsFromUrl();
    const isRightdrawerOpen = useSelector(getRightDrawerStatus);


    // Fetch constructs on init
    useEffect(() => {
        dispatch(invokeGetService('getBlueprintConstructs', []))
            .then(response => {
                if (response?.status) {
                    setClusterlets(response?.data?.clusterlets);
                    setEvents(response?.data?.events);
                    setTransactions(response?.data?.transactions);
                    setRoutingRules(response?.data?.routingRules);
                    setViews(response?.data?.views);
                    setTestsuites(response?.data?.testSuites);
                }
            }).catch(error => {
                console.error(`Fetching constructs failed`)

            })
    }, []);


    const getEventData = (entityId, entityType) => {
        try {
            if (entityType === "routing_rule") {
                const rrdef = routingRules?.find(rrdef => rrdef._id === entityId);
                if (rrdef === undefined) {
                    throw new Error(`Cannot find rrdef with id ${entityId}`)
                }
                const event = events.find(item => item?._id === rrdef.attributes.tcmd);
                if (event === undefined) {
                    throw new Error(`Cannot find event with id ${rrdef.attributes.tcmd}`)
                }
                return event;
            } else {
                const event = events?.find(ev => ev?._id === entityId);
                if (event === undefined) {
                    throw new Error(`Cannot find event with id ${entityId}`)
                }
                return event;
            }

        } catch (error) {
            console.error(`Finding event failed. ${error}`);
            return null;
        }
    }

    const getEventProtocol = (event) => {
        try {
            const srcNode = clusterlets.find((c) => c._id === event?.src);
            const dstNode = clusterlets.find((c) => c._id === event?.dst);
            if (srcNode === undefined || dstNode === undefined) {
                throw new Error(`Cannot find src node and dst node for event '${event._id}'`)
            }

            return srcNode?.type === 1 ? srcNode?.attributes?.type : dstNode?.type === 1 ? dstNode?.attributes?.type : undefined;
        } catch (error) {
            console.error(`Finding event protocol failed. ${error}`);
            return undefined;
        }
    }

    const navigateToPage = (mainEntityId, mainEntityType, subEntity=null) => {
        if(mainEntityId && mainEntityType){
            if(screen === mainEntityType && entityId === mainEntityId && !subEntity) return ;

            if(subEntity){
                history.push(`/blueprint/${slug}/${blueprintId}/${mainEntityType}/${mainEntityId}?testcase=${subEntity._id.toString()}`);
            }else{
                history.push(`/blueprint/${slug}/${blueprintId}/${mainEntityType}/${mainEntityId}`);
            }
        }else if (mainEntityType && (mainEntityId === undefined || mainEntityId === null) ){
             history.push(`/blueprint/${slug}/${blueprintId}/${mainEntityType}`);
        }
     }
    const openConfigurationPanel = ({ mainEntityId, mainEntityType, entityId, entityType, entityItem }) => {
        try {
            let focusElement = {};

            if (mainEntityType === "transaction") {
                focusElement.transaction = mainEntityId;
            }

            if (entityType === "event" || entityType === "routing_rule") {
                const event = getEventData(entityId, entityType)

                focusElement = {
                    ...focusElement,
                    id: event._id,
                    name: event.name,
                    type: "event",
                    mode: 'edit',
                    protocol: getEventProtocol(event),
                    item: event
                }

                if (entityType === "routing_rule") tab = 2;
            } else if (entityType === "child_transaction") {
                const childTransaction = transactions.find(transaction => transaction._id.toString() === entityId);
                if (childTransaction) {
                    focusElement = {
                        ...focusElement,
                        id: entityId,
                        name: childTransaction.name,
                        type: "nested_transaction",
                        mode: 'edit',
                        item: childTransaction,
                    }
                } else {
                    logWarn({ message: `Child transaction data is missing for id ${entityId} in the transaction ${mainEntityId}` })
                }

            } else if (entityType === "clusterlet" || entityType === "analytics" || entityType === "delegate"){
                const clusterlet = clusterlets?.find(item => item?._id.toString() === entityId )
                focusElement = {
                    ...focusElement,
                    id: entityId,
                    name: clusterlet.name,
                    type: entityType === "delegate" ? "external_function" : entityType,
                    mode: 'edit',
                    item: clusterlet,
                }
                if(entityType === "delegate"){
                    focusElement.protocol = clusterlet?.attributes?.type || "";
                }
            }else if (entityType === "view" || entityType === "section" || entityType === "widget") {
                tab = 1
                const view = views?.find(item => item._id.toString() === mainEntityId)
                console.log({view})

                focusElement = {
                    id :  entityId,
                    type : entityType === "widget" ? "ui" : entityType,
                    action: "edit",
                    name: entityItem ? entityItem?.name : view?.name
                }
                if(entityType === "widget"){
                    focusElement.widgetType = entityItem.type
                }
            }else if (entityType === "testsuite" || entityType === "testcase" || entityType === "eventPayload"){

                const testsuite = testsuites?.find(item => item._id.toString() === mainEntityId)

                focusElement = {
                    id : entityType === "eventPayload" ? entityItem?.event_id : entityItem._id,
                    name: entityType === "eventPayload" ? entityItem?.event_name :  entityItem?.name || "",
                    description: entityItem?.description || "",
                    type : entityType === "testcase" ? "simulation_testcases" : entityType,
                    activeTestsuite: testsuite,
                    action: entityType === "testcase" && tab !== 0 ? "edit_context" : "edit",
                }

                if(entityType === "eventPayload"){
                    focusElement.simulation_transaction_id = entityItem?.transaction_id || ""
                }
            }else{
                console.log("----not available----")
                return;
            }
            
            console.log({focusElement, tab})

            if (isRightdrawerOpen && mainEntityType !== "system-model") {
                console.log("--case1--")
                dispatch(toggleRightDrawer());
            }

            if(!isRightdrawerOpen && (mainEntityType === "system-model" || mainEntityType === "testsuite" || mainEntityType === undefined)){
                console.log("--case2--")
                dispatch(toggleRightDrawer());
            }

            dispatch(setTabOnFocus(tab));
            dispatch(setForcedFocus(true));
            dispatch(setFocusElement(focusElement));
           
        } catch (error) {
            console.error(`Opening configuration panel failed. ${error}`);
            return;
        }
    }

    const buildURL = ({entity, entityId}) => {
        return `/blueprint/${slug}/${blueprintId}/${entity}/${entityId}`;
    }

    // Navigation method
    const navigateToConstruct = ({ mainEntityId, mainEntityType, entityId, entityType, entityItem, tabOnfocus=0, subEntity }) => {
        tab = tabOnfocus;
        navigateToPage(mainEntityId, mainEntityType, subEntity);
        openConfigurationPanel({ mainEntityId, mainEntityType, entityId, entityType, entityItem });
    };

    return { navigateToConstruct, buildURL };
};

export default useConstructsNavigation;
